import { SegmentControl } from "./SegmentControl";

const options = [
  { id: "any", label: "Any" },
  { id: "yes", label: "Yes" },
  { id: "no", label: "No" },
];

interface YesNoAnyProps {
  value: boolean | undefined;
  onChange: (value: boolean | undefined) => void;
}

export function YesNoAny({ value, onChange }: YesNoAnyProps) {
  const active = value === undefined ? "any" : value ? "yes" : "no";

  return (
    <SegmentControl
      options={options}
      active={active}
      onChange={(id) => onChange(id === "any" ? undefined : id === "yes")}
    />
  );
}
